module.exports = __webpack_public_path__ + "media/images/sport--bob-3dd46ce28791c5154f049b5c8f539d00.png";